import React, {FunctionComponent} from 'react';
import {Page, route} from 'b302-frontend-library';
import HanButton from '../../utils/HanButton';
import HomeImage from "../../../assets/images/illustratie_home.svg"
import PageCard from '../../layout/PageCard';
import IKnowImage from '../../../assets/images/illustratie_i_know.svg';
import GeneralIdea from '../../../assets/images/illustratie_general_idea.svg';
import NoIdea from '../../../assets/images/illustratie_no_idea.svg';
import KnowStudy from '../../../assets/images/illustratie_know_study.svg';
import {useAuth} from '../../../contexts/AuthContext';

interface Props {
}

const Home: FunctionComponent<Props> = () => {
    const {user} = useAuth();

    const sendMail = (e: any) => {
        e.preventDefault();
        window.open("mailto:outgoing@han.nl");
    };

    return (
        <Page>
            <div className="home">
                <div className="home__intro">
                    <img className="home__intro__image" src={HomeImage} alt="choosing an university"/>
                    <div className="home__intro__text-section">
                        <h1 className="home__intro__text-section__title">Find Your Perfect Study Abroad</h1>
                        <p className="home__intro__text-section__subtitle">Welcome, {user?.name}</p>
                        <p className="home__intro__text-section__text">Thinking about studying abroad? Good choice,
                            spending time abroad not only fulfils academic goals, but also lets you experience a new
                            culture, language, and environment. Jumping into a new experience can be difficult and
                            overwhelming, but luckily for you, we are here to help!</p>
                        <p className="home__intro__text-section__text">Here you will find information about our partner
                            universities, based on the experiences of HAN students, who studied there in the past. They
                            have given their impressions about the university, the campus, the country, etc., which will
                            help you prepare for your Study Abroad adventure.</p>
                        <p className="home__intro__text-section__text">Please note that the content on this website
                            includes personal opinions and viewpoints expressed by students. The information provided is
                            intended for general informational purposes only and should not be relied upon as a
                            substitute for professional advice or judgment. We encourage you to do your own research
                            before making any decisions based on the opinions expressed on this website.</p>
                    </div>
                </div>
                <div className="home__cards">
                    <PageCard image={IKnowImage} imageAlt={"pointing a location"}
                              text={"I know where I would like to go"} link={route('universities')}/>
                    <PageCard image={GeneralIdea} imageAlt={"encircle a location"} text={"I have a general idea"}
                              link={route('select-regions')}/>
                    <PageCard image={NoIdea} imageAlt={"searching a location"} text={"I have a no idea yet"}
                              link={route('explore')}/>
                    <PageCard image={KnowStudy} imageAlt={"study idea"} text={"I know what I would like to study"}
                              link={route('subject-areas', {id: 0})}/>
                </div>
                <div className="home__contact">
                    <h4 className="home__contact__subtitle">Contact Us</h4>
                    <p className="home__contact__text">Questions about Study Abroad?
                        <br/>
                        We are happy to help you.
                    </p>
                    <HanButton
                        onClick={sendMail}
                        disabled={false}
                        modifiers={["margin", "space"]}
                    >
                        Send e-mail to outgoing@han.nl
                    </HanButton>
                </div>
            </div>
        </Page>
    );
};

export default Home;
